enum QuebecObstetricalFilePageIdEnum {
    Page1,
    Page2,
    Page3,
    Page4,
    WeightGainChart
}

export { QuebecObstetricalFilePageIdEnum };
